import {DependencyList, useCallback, useMemo} from 'react';

export function useMap<T, U>(content: T[], selector: (item: T) => U, deps: DependencyList = []) {
    const predicate = useCallback(selector, deps);
    return useMemo(() => content.map(predicate), [content, predicate]);
}
